<script setup lang="ts">
import type { BaseFilterOption } from '~/types/filters';

// PROPS
const {
    itemsFrom,
    itemsTo,
    fromLabel: fromLabelProp,
    toLabel: toLabelProp,
    anyLabel: anyLabelProp,
} = defineProps({
    itemsFrom: { type: Array as PropType<Array<BaseFilterOption<number>>>, required: true },
    itemsTo: { type: Array as PropType<Array<BaseFilterOption<number>>>, required: true },
    fromLabel: { type: String, default: undefined },
    toLabel: { type: String, default: undefined },
    anyLabel: { type: String, default: undefined },
});

// MODELS
const from = defineModel<number | undefined>('from', { required: true });
const to = defineModel<number | undefined>('to', { required: true });

// COMPOSABLES
const { tt } = useTypedI18n();

// DATA
const fromSelectModel = adaptEmptyOptionModel(from);
const toSelectModel = adaptEmptyOptionModel(to);

const fromLabel = computed(() => (fromLabelProp ? fromLabelProp : tt('slp.filters.from')));
const toLabel = computed(() => (toLabelProp ? toLabelProp : tt('slp.filters.to')));
const anyLabel = computed(() => (anyLabelProp ? anyLabelProp : tt('slp.filters.anyOption')));
const fromSelectOptions = computed(() => prependEmptyOption(itemsFrom, anyLabel.value));
const toSelectOptions = computed(() => prependEmptyOption(itemsTo, anyLabel.value));
</script>

<template>
    <UFormField :label="fromLabel" class="sm:grow">
        <USelectMenu v-model="fromSelectModel" :items="fromSelectOptions" :search-input="false" value-key="value" />
    </UFormField>
    <UFormField :label="toLabel" class="sm:grow">
        <USelectMenu v-model="toSelectModel" :items="toSelectOptions" :search-input="false" value-key="value" />
    </UFormField>
</template>
